export default "__VITE_ASSET__CIB9lxOT__"